module.exports = __webpack_public_path__ + "static/media/exam.0438d477.png";